import { sizes } from '../GlobalStyles';
import styled from 'styled-components';

const getSpace = (x: number) => {
    return x * 4;
};

export const Body = styled.div`
    display: flex;
    margin: 0px;
    align-items: center;
    justify-content: center;
    @media (max-width: ${sizes.desktop}px) {
        margin: 0px ${({ theme }) => getSpace(theme.x)}px;
        height: auto;
    }
    height: 100%;
`;

export const Header = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: ${({ theme }) => theme.x * 2}px ${({ theme }) => getSpace(theme.x)}px;

    .logo {
        display: none;
        width: 160px;
    }

    @media (max-width: ${sizes.desktop}px) {
        /* padding: 0px; */
        .logo {
            display: block;
        }
        position: relative;
    }
`;

export const Left = styled.div`
    position: relative;
    flex: 1;
    height: 100%;
    /* padding: 16px 0px; */
    box-sizing: border-box;

    @media (max-width: ${sizes.desktop}px) {
        display: none;
    }
`;

export const LeftLogoWrapper = styled.div`
    height: 100%;
    display: inline-block;
    position: relative;
`;

export const Center = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    margin: 0px ${({ theme }) => getSpace(theme.x)}px;
    padding: ${({ theme }) => getSpace(theme.x)}px 0px;

    @media (max-width: ${sizes.desktop}px) {
        margin: 0px;
        padding: 0px;
    }
`;

export const Right = styled.div`
    flex: 1;
    height: 100%;
    text-align: right;
    box-sizing: border-box;
    padding: 0px ${({ theme }) => getSpace(theme.x)}px;

    @media (max-width: ${sizes.desktop}px) {
        display: none;
    }
`;

export const Form = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0px auto;
    width: 100%;
    max-width: 400px;
    @media (min-width: ${sizes.desktop}px) {
        min-width: 500px;
    }
`;

export default {
    Body,
    Center,
    Form,
    Header,
    Left,
    LeftLogoWrapper,
    Right,
};
